import React, { useEffect } from "react";
import AppLayout from "../../layouts/AppLayout";
import VideoPlayerButton from "../../components/common/VideoPlayerButton";
import { HeroSection } from "../../components/landing/HeroSection";
import { BenefitsSection } from "../../components/landing/BenefitsSection";
import { TailoredSolutionsSection } from "../../components/landing/TailoredSolutionsSection";
import { TestimonialsSection } from "../../components/landing/TestimonialsSection";
import { CTASection } from "../../components/landing/CTASection";
import { LatestBlogs } from "../../components/landing/LatestBlogs";
import { LatestGuides } from "../../components/landing/LatestGuides";
import { seoConfig } from "../../config/seoConfig";

export default function Home() {
  // OUT-949: the extension deeplink / auth handoff now runs route-independently via
  // useExtensionDeeplinkHandoff in App.jsx (AppLayout reads isExtensionInstalled from AppContext),
  // so it works on the live homepage (`/` -> NewHomepage2) too, not only on this legacy page.
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
  }, []);

  const afterContactUs = (
    <>
      <LatestBlogs />
      <LatestGuides />
    </>
  );

  return (
    <>
      <AppLayout
        {...{
          afterContactUs,
          pageConfig: seoConfig.homePage,
        }}
      >
        <HeroSection />
        <BenefitsSection />
        <TailoredSolutionsSection />
        <TestimonialsSection />
        <CTASection />
      </AppLayout>
      <VideoPlayerButton />
    </>
  );
}
